// @flow
import { connect } from 'react-redux';

import ContactForm7 from 'components/contactForm7';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/contactForm7';
import { fetchCF7ContactForm, fetchSingleCF7FormContact, resetCF7ContactFormStatus } from 'actions/contactForm7Actions';

export default connect(
  (state: StateType): StateProps => ({
    singleContactForm: state.contactForm7State.singleContactForm,
    fetchStatus: state.contactForm7State.fetchStatus,
    sendStatus: state.contactForm7State.sendStatus
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchCF7ContactForm: () => dispatch(fetchCF7ContactForm()),
    fetchSingleCF7FormContact: (id: number) => dispatch(fetchSingleCF7FormContact(id)),
    resetCF7ContactFormStatus: () => dispatch(resetCF7ContactFormStatus())
  })
)(ContactForm7);
